import React from "react";

import { Button } from "antd";
import Modal from "antd/es/modal/Modal";
import "./COADeleteModal.css";

export default function COADeleteModal(props) {
  const { toggleShowDeleteModal, apiDeleteCoa, deleteLoading = false } = props;
  return (
    <Modal
      open
      closable={false}
      centered
      footer={null}
      maskClosable={!deleteLoading}
      onCancel={deleteLoading ? undefined : toggleShowDeleteModal}
      width={368}
      wrapClassName="COADeleteModal"
      className="COADeleteModal"
    >

      <div className="deleteModal">
        <div className="deleteModalSpanContainer">
          <span className="deleteModalHeader"> Delete report </span>
          <span className="deleteModalBody"> Are you sure you want to delete this report? </span>
        </div>
        <div className="deleteModalButtonContainer">
          <Button
            type="default"
            disabled={deleteLoading}
            onClick={toggleShowDeleteModal}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            loading={deleteLoading}
            disabled={deleteLoading}
            onClick={apiDeleteCoa}
          >
            Delete
          </Button>
        </div>

      </div>
    </Modal>
  );
}
